import { createActionCreator } from 'reducers/utils/helpers';

import {
  FUNDING_DOCUMENT_UPLOAD_FAILURE,
  FUNDING_DOCUMENT_UPLOAD_PROGRESS,
  FUNDING_DOCUMENT_UPLOAD_START,
  FUNDING_DOCUMENT_UPLOAD_SUCCESS,
  GET_DOCUMENT_LINK,
  REQUEST_FUNDING_SEARCH_DOCUMENT_LINK,
  REQUEST_FUNDING_SEARCH_DOCUMENTS_LINK,
  REQUEST_REMOVE_FUNDING_DOCUMENT,
} from './types';

export const fundingDocumentUploadFailure = createActionCreator(
  FUNDING_DOCUMENT_UPLOAD_FAILURE,
  'identifier',
  'error',
);

export const fundingDocumentUploadProgress = createActionCreator(
  FUNDING_DOCUMENT_UPLOAD_PROGRESS,
  'identifier',
  'progress',
);

export const fundingDocumentUploadStart = createActionCreator(
  FUNDING_DOCUMENT_UPLOAD_START,
  'identifier',
  'fundingSearchId',
  'documentType',
  'files',
);

export const fundingDocumentUploadSuccess = createActionCreator(
  FUNDING_DOCUMENT_UPLOAD_SUCCESS,
  'identifier',
  'documents',
);

export const requestDocumentLink = createActionCreator(
  GET_DOCUMENT_LINK,
  'documentId',
  'route',
  'promise',
);

export const requestFundingDocumentLink = createActionCreator(
  REQUEST_FUNDING_SEARCH_DOCUMENT_LINK,
  'fundingSearchId',
  'documentId',
  'promise',
);

export const requestFundingSearchDocumentsLink = createActionCreator(
  REQUEST_FUNDING_SEARCH_DOCUMENTS_LINK,
  'fundingSearchId',
  'promise',
);

export const requestRemoveFundingDocument = createActionCreator(
  REQUEST_REMOVE_FUNDING_DOCUMENT,
  'fundingSearchId',
  'documentId',
);
